// Marketing footer — 4-column layout (brand wide + Product + Resources + Company) + bottom row.
// Source canonical: design-system/project/homepage/index.html § <footer>

import AirgentLogo from '../components/AirgentLogo';
import Wordmark from '../components/Wordmark';

const COLUMNS: { heading: string; links: { label: string; href: string }[] }[] = [
  {
    heading: 'Product',
    links: [
      { label: 'Roster',       href: '#roster' },
      { label: 'How it works', href: '#how' },
      { label: 'Pricing',      href: '#pricing' },
      { label: 'Roadmap',      href: '#roadmap' },
      { label: 'Changelog',    href: '/changelog' },
    ],
  },
  {
    heading: 'Resources',
    links: [
      { label: 'Why Airgent',      href: '#why' },
      { label: 'Field notes',      href: '/blog' },
      { label: 'Customer stories', href: '/stories' },
      { label: 'Documentation',    href: '/docs' },
      { label: 'API reference',    href: '/api' },
    ],
  },
  {
    heading: 'Company',
    links: [
      { label: 'About',           href: '/about' },
      { label: 'Careers · hiring', href: '/careers' },
      { label: 'Contact',         href: 'mailto:hello@airgent.ai' },
      { label: 'Press kit',       href: '/press' },
      { label: 'Investor brief',  href: '/investors' },
    ],
  },
];

const SOCIAL: { label: string; href: string }[] = [
  { label: 'X',        href: 'https://x.com/airgentai' },
  { label: 'LinkedIn', href: 'https://linkedin.com/company/airgent' },
  { label: 'GitHub',   href: 'https://github.com/airgent' },
];

const LEGAL: { label: string; href: string }[] = [
  { label: 'Privacy',  href: '/privacy' },
  { label: 'Terms',    href: '/terms' },
  { label: 'Security', href: '/security' },
];


export default function Footer() {
  return (
    <footer
      style={{
        padding: '64px 40px 28px',
        background: '#0E0E0C',
        color: '#908A82',
        borderTop: '1px solid rgba(255,255,255,0.06)',
      }}
    >
      <div
        className="footer-grid"
        style={{
          maxWidth: 1200, margin: '0 auto',
          display: 'grid',
          gridTemplateColumns: '1.6fr 1fr 1fr 1fr',
          gap: 40, alignItems: 'flex-start',
        }}
      >
        {/* Brand column (wide) */}
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <AirgentLogo size={28} />
            <Wordmark size="xs" name="Operators" />
          </div>
          <p
            style={{
              fontFamily: 'Inter Tight, system-ui, sans-serif',
              fontSize: 14.5, fontWeight: 400,
              lineHeight: 1.65, letterSpacing: '-0.005em',
              marginTop: 18, maxWidth: 340,
              color: '#C7C3BD',
            }}
          >
            AI employees for Indian businesses. Hire the role; we run the rest.
          </p>
          <div style={{ marginTop: 18 }}>
            <span className="status-pill-mint">
              <span className="dot" />
              All systems normal
            </span>
          </div>
          <div style={{ display: 'flex', gap: 14, marginTop: 22 }}>
            {SOCIAL.map((s) => (
              <a
                key={s.label}
                href={s.href}
                aria-label={s.label}
                style={{
                  display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                  width: 32, height: 32, borderRadius: 8,
                  background: '#232120',
                  border: '1px solid rgba(255,255,255,0.06)',
                  color: '#C7C3BD',
                  fontFamily: 'Inter Tight, system-ui, sans-serif',
                  fontSize: 11, fontWeight: 600,
                  textDecoration: 'none',
                }}
              >
                {s.label[0]}
              </a>
            ))}
          </div>
        </div>

        {/* Link columns */}
        {COLUMNS.map((col) => (
          <div key={col.heading}>
            <div
              style={{
                fontFamily: 'IBM Plex Mono, monospace',
                fontSize: 11, fontWeight: 700,
                letterSpacing: '0.14em', textTransform: 'uppercase',
                color: '#F5F4F2', marginBottom: 6,
              }}
            >
              {col.heading}
            </div>
            <ul style={{ listStyle: 'none', padding: 0, margin: '14px 0 0', display: 'flex', flexDirection: 'column', gap: 10 }}>
              {col.links.map((l) => (
                <li key={l.label}>
                  <a href={l.href} className="footer-link">{l.label}</a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      {/* Bottom row */}
      <div
        className="footer-bottom"
        style={{
          maxWidth: 1200, margin: '52px auto 0',
          paddingTop: 24,
          borderTop: '1px solid rgba(255,255,255,0.06)',
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          flexWrap: 'wrap', gap: 16,
          fontSize: 12.5, color: '#908A82',
          fontFamily: 'Inter Tight, system-ui, sans-serif',
          letterSpacing: '-0.005em',
        }}
      >
        <span>© 2026 Airgent Labs · Mumbai · Bangalore</span>
        <div style={{ display: 'flex', gap: 22, alignItems: 'center' }}>
          {LEGAL.map((l) => (
            <a key={l.label} href={l.href} className="footer-link-mini">{l.label}</a>
          ))}
          <span style={{ fontFamily: 'IBM Plex Mono, monospace', fontSize: 11.5, color: '#5A554F', letterSpacing: '0.04em' }}>
            airgent.ai · private beta
          </span>
        </div>
      </div>
    </footer>
  );
}
